import {EChartsOption} from "echarts";
import {formatCurrency} from "@angular/common";
import {Backend} from '@generated-backend-types';
import Chart = Backend.App.Resources.Dashboard.Statistics.Chart;

export function generateChartOption(chartResponseData: Chart): EChartsOption {
  const option: EChartsOption = {
    color: [
      '#337ab7',
      '#2b384d',
      '#8fbadd',
      '#8893a1',
      '#d1e2f1',
      '#c9d0d8',
    ],
    title: {
      text: chartResponseData.chart_label
    },
    legend: {
      show: true,
      right: 0,
    },
    grid: {
      left: '2%',
      right: '6%',
      bottom: '5%',
      containLabel: true
    },
    // @ts-expect-error" - Typing Problem
    tooltip: {
      show: true,
      trigger: 'item',
      valueFormatter: value => {
        if(typeof value === 'number' || typeof value === 'string') {
          return formatter(
            value,
            chartResponseData.chart_type === 'horizontal_bar_chart' ? chartResponseData.x_axis.format : chartResponseData.y_axis.format,
          )
        } else {
          return value?.toString ?? '';
        }
      }
    }
  };
  switch (chartResponseData.chart_type) {
    case 'vertical_bar_chart':
    case 'drilldown_vertical_bar_chart':
      option.yAxis = {
        type: "value",
        name: chartResponseData.y_axis.label,
        axisLabel: {
          formatter: value => {
             return formatter(value, chartResponseData.y_axis.format);
          }
        }
      };
      option.xAxis = {
        type: "category",
        name: chartResponseData.x_axis.label,
        data: chartResponseData.data_labels,
        nameLocation: "middle",
        nameGap: 25
      };
      break;
    case 'horizontal_bar_chart':
      option.yAxis = {
        type: "category",
        name: chartResponseData.y_axis.label,
        data: chartResponseData.data_labels,
      };
      option.xAxis = {
        type: "value",
        name: chartResponseData.x_axis.label,
        nameLocation: "middle",
        nameGap: 25,
        axisLabel: {
          formatter: value => {
            return formatter(value, chartResponseData.x_axis.format);
          }
        }
      }
  }
  option.series = chartResponseData.series.map(series => {
    // let labelPosition = 'top';
    switch (chartResponseData.chart_type) {
      case 'horizontal_bar_chart':
        // labelPosition = 'right';
        break;
    }
    return {
      ...series,
      type: 'bar',
      emphasis: {
        focus: chartResponseData.chart_type === 'drilldown_vertical_bar_chart' ? 'self' : 'series'
      },
      label: {
        show: false,
        // Context - Looks to messy with too much data
        // position: labelPosition,
        // formatter: (data: {value: string | number}) => {
        //   return formatter(
        //     data.value,
        //     chartResponseData.chart_type === 'horizontal_bar_chart' ? chartResponseData.x_axis.format : chartResponseData.y_axis.format,
        //     locale
        //   )
        // }
      },
    }
  });
  return option;
}

function formatter(value: number | string, format: string): string {
  switch (format) {
    case 'currency':
      return formatCurrency((value as number / 100), 'de', '€', 'EUR', '1.2-2');
    case 'number':
    case 'text':
    default:
      return `${value}`;
  }
}
